export default function applyTheme(settings) {
  const html = document.documentElement;

  html.classList.remove(
    "a11y-high-contrast",
    "a11y-black-white",
    "a11y-reduce-motion",
    "a11y-reduce-transparency"
  );

  if (settings.layout.highContrast) {
    html.classList.add("a11y-high-contrast");
  }

  if (settings.layout.blackWhite) {
    html.classList.add("a11y-black-white");
  }

  if (settings.layout.reduceMotion) {
    html.classList.add("a11y-reduce-motion");
  }

  if (settings.layout.reduceTransparency) {
    html.classList.add("a11y-reduce-transparency");
  }
}